<template>
  <div>
    <slot name="error" :props_error="errors" />
  </div>
</template>

<script>
import api from '@/services/api'
export default {
  name: 'c-handler-error',
  data() {
    return {
      errors: {
        network: false
      }
    }
  },
  created() {
    this.handlerError()
    this.listenerNetworkConnect()
  },
  methods: {
    handlerError() {
      // Проверяем ответ в headers
      api.interceptors.response.use((response) => {
        return response
      },
      error => {

        const url = error.config.url
        const outputError = (message, endpoint_url = url) => {
          let text = `API ...${endpoint_url}: ${message}`
          this.$toasted.error(text, {
            icon: 'warning'
          })
        }

        if (error.response) {
          // Если 401, отправить на переавторизацию
          if (error.response.status === 401) {
            localStorage.clear()
            location.reload()
          } else if (error.response.status === 404) {
            return false
          } else {
            /* if (error.message) {
              this.$toasted.error(JSON.stringify(error.message), {
                icon: 'warning'
              })
            } else {
              this.$toasted.error(JSON.stringify(error), {
                icon: 'warning'
              })
            } */
          }
        }

        // Выводим ошибку только для определенных URL
        if(url == 'routes/' || url == 'route-types/' || url == 'stops/') {
          outputError(error.message)
        }

        return Promise.reject(error)
      })
    },

    toogleFlagErrors(key, val) {
      this.errors[key] = val
    },

    listenerNetworkConnect() {
      window.addEventListener('online', () => {
        this.toogleFlagErrors('network', false)
      }, false)

      window.addEventListener('offline', () => {
        this.toogleFlagErrors('network', true)
      }, false)
    }
  },
  beforeDestroy() {
    window.removeEventListener('online', this.toogleFlagErrors('network', false), false)
    window.removeEventListener('offline', this.toogleFlagErrors('network', true), false)
  }
}
</script>